import { Injectable } from "@angular/core";
import { HttpResponse, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs'
import { WsiError, WsiErrorExt } from '../interfaces/wsi.errors';
import { throwError } from 'rxjs';

/**
* WSI helper service.
*/
@Injectable()
export class WsiUtilityService {
    public httpGetDefaultHeader(authToken: String = undefined): HttpHeaders {
        let headers: HttpHeaders = new HttpHeaders();
        headers.append("Accept", "application/json ");
        headers.append("Access-Control-Allow-Origin", "*");
        if (authToken !== undefined) {
            headers.append("Authorization", "Bearer " + authToken);
        }
        return headers;
    }

    public httpPostDefaultHeader(authToken: String = undefined): HttpHeaders {
        let headers: HttpHeaders = this.httpGetDefaultHeader(authToken);
        headers.append("Content-Type", "application/json; charset=utf-8");
        return headers;
    }

    public httpDeleteDefaultHeader(authToken: String = undefined): HttpHeaders {
        return this.httpGetDefaultHeader(authToken);
    }


    public extractData(res: Response, traceModule: string, method: string): any {
        if (res.status < 200 || res.status >= 300) {
            throw new Error("Bad response status: " + res.status);
        }
        try {
            let body: any = res;
            if (Array.isArray(body) === true) {
                let traceStr: string = "";
                (<Array<any>>body).forEach(item => {
                    traceStr = traceStr + "\n\n" + JSON.stringify(item);
                });
            }
            return body;
        }
        catch (exc) {
            console.log("Response not handled properly; exception caught: ", res.url, "; url=", exc.toString());
        }
    }

    public handleError(error: Response | any, traceModule: string, method: string, redirectonFailedAuth: boolean = true): Observable<any> {
        try {
            let wsiError: any;
            if (error instanceof Response) {
                if (error.status === 400) {
                    let body: any = error;
                    wsiError = new WsiErrorExt(new WsiError(error.status, error.statusText, body.Error, body.Id, body.Details));
                }
                else if (error.status === 401) {
                    wsiError = new WsiErrorExt(new WsiError(error.status, error.statusText, undefined, undefined, "Authentication failed. User token is invalid."));
                    // do redirect in case redirectonFailedAuth == true
                    if (redirectonFailedAuth === true) {
                        //this.router.navigate(["/loginpage"]);
                    }
                }
                else if (error.status === 404) {
                    wsiError = new WsiErrorExt(new WsiError(error.status, error.statusText, undefined, undefined, error.toString()));
                }
                else {
                    wsiError = new WsiErrorExt(new WsiError(error.status, error.statusText, undefined, undefined, error.toString()));
                }
            }
            else {
                let errMsg: string = error.message ? error.message : error.toString();
                wsiError = new WsiErrorExt(errMsg);
            }
            return throwError(wsiError);
        }
        catch (exc) {
            let wsiError: WsiErrorExt = new WsiErrorExt("WSI reply error! See trace.");
            return throwError(wsiError);
        }
    }

}